<template>
  <div>
    <p
      :style="dataField['style']"
      :class="dataField['class']"
    >{{ dataField.title ? dataField.title : "" }}</p>
  </div>
</template>

<script>
export default {
  props: ["dataField"],
  name: "TextBox",
  data: () => ({}),
};
</script>
